import { useEffect } from 'react';
import { QueryClient, useQueryClient } from '@tanstack/react-query';
import { RealtimeStatus, useRealtime } from '@/context/RealtimeContext';
import { calendarKeys } from './calendarQueries';

interface CalendarRealtimeEvent { type: string; workspace_id: string; payload: { domain: 'calendar'; type: string; id: string } }
const events = new Set([
  'calendar.event.created', 'calendar.event.updated', 'calendar.event.deleted',
  'calendar.assignments.updated', 'calendar.group.created', 'calendar.group.updated',
  'calendar.group.deleted', 'calendar.attachment.created', 'calendar.attachment.deleted',
]);
export const handleCalendarRealtime = (client: QueryClient, workspaceId: string, event: CalendarRealtimeEvent): void => {
  if (!workspaceId || event.workspace_id !== workspaceId || !events.has(event.type) || event.payload?.domain !== 'calendar' || !event.payload.id) return;
  void client.invalidateQueries({ queryKey: calendarKeys.root(workspaceId) });
};
export const useCalendarRealtime = (workspaceId: string): { status: RealtimeStatus } => {
  const client = useQueryClient(); const { subscribe, status } = useRealtime();
  useEffect(() => workspaceId ? subscribe(event => handleCalendarRealtime(client, workspaceId, event as CalendarRealtimeEvent)) : undefined, [client, subscribe, workspaceId]);
  return { status };
};
